<section class="py-3 bg-light">
  <div class="container-xl">
    <div class="row justify-content-center">
      <div class="col col-lg-9">
        <app-search-input (search)="search($event)" />
      </div>
    </div>
  </div>
</section>
<app-home-hero />
<app-newsletter />
<app-explore-grid />
<app-popular-grid [light]="true" />
<app-partners-logos />
<app-quote-block />
<app-text-block>
  <ng-container heading> Helping you Champion Your Charity.</ng-container>
  <ng-container content>
    <p class="mb-5">
      Charity Booster provides easy-to-use travel packages to increase the impact of your mission with less stress for
      your team.
    </p>
    <button (click)="loadChatBox()" class="btn btn-primary mt-1 btn-lg mb-5 mb-md-0" type="button">
      Chat with us today!
    </button>
  </ng-container>
</app-text-block>
<app-stats-block />
<app-testimonials />
<!--<app-partners>-->
<!--  <ng-container class="img-content">-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img purple ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img info ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img success ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img success ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img purple ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-6 col-lg-4">-->
<!--      <div class="single-person d-flex flex-column align-items-center">-->
<!--        <div class="single-person__img info ratio ratio-1x1 rounded-circle overflow-hidden mb-4">-->
<!--          <img alt="Person" class="img-cover" src="assets/images/demo/homepage/avatar.png" />-->
<!--        </div>-->
<!--        <h3 class="h5">Paul Price</h3>-->
<!--        <p class="fs-sm">Professional</p>-->
<!--      </div>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--  <ng-container class="badge-content">Our partnership</ng-container>-->
<!--  <ng-container class="title-content">Our partners we’re proud to represent.</ng-container>-->
<!--  <ng-container class="description-content">-->
<!--    You’ve heard it said, “80% of the work is done by 20% of the people.” If you work for a charity then you’re all too-->
<!--    familiar with this expression. We are dedicated to helping charities win by providing best in-class services because-->
<!--    Your Cause is Our Cause.-->
<!--  </ng-container>-->
<!--  <a class="btn btn-content btn-primary text-uppercase" routerLink="/">See all our partners</a>-->
<!--</app-partners>-->

<!--<app-img-block>-->
<!--  <span class="badge-content">Fundraising</span>-->
<!--  <span class="title-content">Become a service provider</span>-->
<!--  <span class="description-content"-->
<!--    >Charity Booster is a growing marketplace made especially for those responsible for raising funds for-->
<!--    Charities.</span-->
<!--  >-->
<!--  <a class="btn btn-content btn-primary text-uppercase" routerLink="/"> Experience Now </a>-->
<!--  <img alt="Test Alt" class="img img-content img-fluid rounded" src="assets/images/demo/homepage/image-block.png" />-->
<!--</app-img-block>-->

<!--<app-img-block>-->
<!--  <span class="badge-content">Fundraising</span>-->
<!--  <span class="title-content">Become a service provider</span>-->
<!--  <span class="description-content"-->
<!--    >Charity Booster is a growing marketplace made especially for those responsible for raising funds for-->
<!--    Charities.</span-->
<!--  >-->
<!--  <a class="btn btn-content btn-primary text-uppercase" routerLink="/"> Experience Now </a>-->
<!--  <img alt="Test Alt" class="img img-content img-fluid rounded" src="assets/images/demo/homepage/image-block.png" />-->
<!--</app-img-block>-->

<!--<ng-container-->
<!--  *ngIf="{-->
<!--    categories: categoriesSlice$ | async-->
<!--  } as data"-->
<!--&gt;-->
<!--  <ng-container *ngIf="(categoriesCallState$ | async)?.LOADING">-->
<!--    &lt;!&ndash;    <app-spinner class="small"></app-spinner>&ndash;&gt;-->
<!--  </ng-container>-->

<!--  <ng-container *ngIf="(categoriesCallState$ | async)?.FAILURE">-->
<!--    <span>Error</span>-->
<!--  </ng-container>-->

<!--  <ng-container *ngIf="(categoriesCallState$ | async)?.LOADED">-->
<!--    <app-popular-categories-->
<!--      [categories]="data.categories"-->
<!--      [exploreAllRoute]="exploreAllCategoriesRoute"-->
<!--      class="d-block pb-7 mb-6"-->
<!--    ></app-popular-categories>-->
<!--  </ng-container>-->
<!--</ng-container>-->
